import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var getCartQuantity = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
		var response, data;
		return _regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return fetch('/cart.js', {
							method: 'get'
						});

					case 2:
						response = _context.sent;
						_context.next = 5;
						return response.json();

					case 5:
						data = _context.sent;
						return _context.abrupt('return', data.item_count);

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function getCartQuantity() {
		return _ref.apply(this, arguments);
	};
}();

/**
 * Get initial Selected Options Object
 * @param  {array} options - array of options objects
 * @return  {object} initialOptions - sets the first value of each option as initial value
 */
export var getInitialSelectedOptions = function getInitialSelectedOptions(options) {
	var initialOptions = {};
	options.forEach(function (option) {
		initialOptions[option.name] = option.values[0];
	});
	return initialOptions;
};

export var productVariantFromBase64String = function productVariantFromBase64String(string) {
	var splitString = atob(string).split('/');
	return splitString[splitString.length - 1];
};

export var addCartNote = function addCartNote(cartNoteObject) {
	console.log('starting cart note....');
	var cartnote = [localStorage.getItem('cartnote')];
	cartnote.push(cartNoteObject);

	localStorage.setItem('cartnote', cartnote);
	console.log("CART NOTE", cartnote);
	// const request = {note: cartNoteObject}
	// fetch('/cart/update.js', {
	// 	method: 'post',
	// 	headers: {
	// 		'Content-Type': 'application/json'
	// 	},
	// 	body: JSON.stringify(request)
	// })
	// 	.then(response => response.json())
	// 	.then(data => {
	// 		console.log('cart note data',data)
	// 	})
	// 	.catch(error => {
	// 		console.log('cart note error', error)
	// 	})
};

export var addVariantsToCart = function addVariantsToCart(arrayOfVariantObjects) {
	Shopify.queue = arrayOfVariantObjects;
	getCartQuantity().then(function (cart_quantity) {
		Shopify.moveAlong = function () {
			if (Shopify.queue.length) {
				var request = Shopify.queue.shift();
				var _variant_count = request.quantity;
				console.log(_variant_count);

				fetch('/cart/add.js', {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(request)
				}).then(function (response) {
					return response.json();
				}).then(function (data) {
					cart_quantity += _variant_count;
					Shopify.moveAlong();
				}).catch(function (error) {
					console.log(error);
					if (Shopify.queue.length) {
						Shopify.moveAlong();
					} else {
						addToCartOk(cart_quantity);
					}
				});
			} else {
				cart_quantity += variant_count;
				addToCartOk(cart_quantity);
			}
		};
		Shopify.moveAlong();
	});
};

export var addToCartOk = function addToCartOk(cart_quantity) {
	console.log('cart update count', cart_quantity);
	document.getElementById('cart_count').innerHTML = cart_quantity;
};